//@ts-nocheck
/**
 * src/routes/sections/adminRoutes.tsx
 * ---------------------------------------------------------------------------
 * Admin / CMS section routes.
 * All routes are nested under /web-twinprocms.
 *
 * Extracted from the monolithic routes.tsx for domain separation.
 * All route paths, components, and AuthGuard wrapping are preserved exactly.
 */
import React from 'react';
import { paths } from '../paths';

// Layout & Guard
import AdminLayout from '../../layouts/AdminLayout';
import { AuthGuard } from '../../guard/AuthGuard';

// Admin pages (imported from their legacy Pages/ locations — unchanged)
import Dashboard from '../../Pages/Dashboard/Dashboard';
import Scene from '../../Pages/Scene/Scene';
import SceneCreate from '../../Components/SceneCreate/SceneCreate';
import Categories from '../../Pages/Categories/Categories';
import CategoryCreate from '../../Components/CategoryCreate/CategoryCreate';
import CategoryFilters from '../../Pages/Category-Filter/CategoryFilters';
import UnityScene from '../../Pages/UnityScene/UnityScene';
import UnitySceneCreate from '../../Components/UnitySceneCreate/UnitySceneCreate';
import User from '../../Pages/User/User';
import UsersCreate from '../../Components/UsersCreate/UsersCreate';
import Audit from '../../Pages/Audit/Audit';
import FileLibrary from '../../Pages/FileLibrary/FileLibrary';
import BasicSettings from '../../Pages/Settings/BasicSettings/BasicSettings';
import Filters from '../../Pages/Settings/Filters/Filters';
import HomepageOptions from '../../Pages/Settings/HomepageOptions/HomepageOptions';
import ShareIcon from '../../Pages/Settings/ShareIcon/ShareIcon';
import ThemeOptions from '../../Pages/Settings/ThemeOptions/ThemeOptions';
import WebUrls from '../../modules/webUrls/pages/WebUrlsList/WebUrls';
import WebUrlCreate from '../../modules/webUrls/components/WebUrlCreate/WebUrlCreate';
import Tours from '../../Pages/Tours/Tours';

/**
 * Builds admin/CMS route config.
 * @param {object} options
 * @param {any} options.user  - Logged-in user object (for AuthGuard role checks)
 * @param {boolean} options.isLoading - Loading state for AdminLayout
 */
export const adminRoutes = ({ user, isLoading }) => [
  {
    path: paths.admin.root,
    element: (
      <AuthGuard loggedInUser={user}>
        <AdminLayout user={user} isLoading={isLoading} />
      </AuthGuard>
    ),
    children: [
      { path: 'dashboard', element: <Dashboard /> },
      {
        path: 'scene',
        children: [
          { index: true, element: <AuthGuard loggedInUser={user}><Scene /></AuthGuard> },
          { path: 'create', element: <AuthGuard loggedInUser={user}><SceneCreate /></AuthGuard> },
          { path: ':id/update/:public_id', element: <SceneCreate /> },
        ],
      },
      {
        path: 'categories',
        children: [
          { index: true, element: <AuthGuard loggedInUser={user}><Categories /></AuthGuard> },
          { path: 'create', element: <AuthGuard loggedInUser={user}><CategoryCreate /></AuthGuard> },
          { path: ':id/update', element: <CategoryCreate /> },
        ],
      },
      { path: 'category-filters', element: <AuthGuard loggedInUser={user}><CategoryFilters /></AuthGuard> },
      {
        path: 'unity-scene',
        children: [
          { index: true, element: <UnityScene /> },
          { path: 'create', element: <UnitySceneCreate /> },
          { path: ':id/update', element: <UnitySceneCreate /> },
        ],
      },
      {
        path: 'web-urls',
        children: [
          { index: true, element: <AuthGuard loggedInUser={user}><WebUrls /></AuthGuard> },
          { path: 'create', element: <AuthGuard loggedInUser={user}><WebUrlCreate /></AuthGuard> },
          { path: ':id/update', element: <WebUrlCreate /> },
        ],
      },
      {
        path: '360-tours',
        children: [
          { index: true, element: <Tours /> },
        ],
      },
      {
        path: 'users',
        children: [
          { index: true, element: <AuthGuard loggedInUser={user}><User /></AuthGuard> },
          { path: 'create', element: <AuthGuard loggedInUser={user}><UsersCreate /></AuthGuard> },
          { path: ':id/update', element: <UsersCreate /> },
        ],
      },
      {
        path: 'audit',
        children: [
          { index: true, element: <AuthGuard loggedInUser={user}><Audit /></AuthGuard> },
        ],
      },
      {
        path: 'file-library',
        children: [
          { index: true, element: <FileLibrary /> },
          { path: ':id', element: <FileLibrary /> },
        ],
      },
      { path: 'basic-settings', element: <AuthGuard loggedInUser={user}><BasicSettings /></AuthGuard> },
      { path: 'filters', element: <AuthGuard loggedInUser={user}><Filters /></AuthGuard> },
      { path: 'homepage-options', element: <AuthGuard loggedInUser={user}><HomepageOptions /></AuthGuard> },
      { path: 'share-icon', element: <AuthGuard loggedInUser={user}><ShareIcon /></AuthGuard> },
      { path: 'theme-options', element: <AuthGuard loggedInUser={user}><ThemeOptions /></AuthGuard> },
    ],
  },
];
